<template>
  <div class="button-select">
    <Button
      v-for="option in options"
      :key="option.value"
      size="md"
      :type="selectedValue === option.value ? 'primary' : 'secondary'"
      @click="onOptionClick(option)"
    >
      {{ option.label }}
    </Button>
  </div>
</template>

<script setup lang="ts">
  import Button from "../buttons/Button.vue";

  export interface ButtonSelectOption {
    label: string;
    value: string;
  }

  export interface ButtonSelectProps {
    options: ButtonSelectOption[];
  }

  const props = withDefaults(defineProps<ButtonSelectProps>(), {
    options: () => [],
  });
  const selectedValue = defineModel<string | null>({ default: null });

  function onOptionClick(option: ButtonSelectOption) {
    selectedValue.value = option.value;
  }
</script>

<style lang="scss">
  .button-select {
    display: flex;
    align-items: center;
    gap: 16px;
  }
</style>
